/**
 * Identifiant d'opération déterministe (UUID v5 dérivé d'un texte) : une action automatique
 * rejouée plusieurs fois (réservation d'une échéance, par exemple) porte toujours le même
 * identifiant, et la base ne l'enregistre qu'une fois.
 */
export async function stableUuid(text: string): Promise<string> {
  const digest = new Uint8Array(
    await crypto.subtle.digest('SHA-1', new TextEncoder().encode(`centime:${text}`)),
  )
  const bytes = digest.slice(0, 16)
  bytes[6] = ((bytes[6] ?? 0) & 0x0f) | 0x50
  bytes[8] = ((bytes[8] ?? 0) & 0x3f) | 0x80
  const hex = [...bytes].map((byte) => byte.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
